import {DataSource} from "@/datasources/consulte-grid";
import {BibDocumentoPesquisaModel} from '@/models/biblioteca/bibdocumento/bibdocumentopesquisa.model';
import BibDocumentoService from "@/services/biblioteca/bibdocumento/bibdocumento.service";

export default class BibDocumentoPesquisaDataSource extends DataSource<BibDocumentoPesquisaModel> {
 constructor(pageNumber: number, rowsPerPage: number, rowsPageCount: number, totalRowCount: number, Rows: BibDocumentoPesquisaModel[], onLoad?: (rows: any) => void) {
  super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<BibDocumentoPesquisaModel>())
  if (onLoad)
   this.setOnLoad(onLoad);
 }

 async load() : Promise<any> {
  const result = ((await BibDocumentoService.dadosPesquisa(this.pageNumber, this.rowsPerPage, this.filters)).data as any) as DataSource<BibDocumentoPesquisaModel>;
  console.log(result);
  this.pageNumber = result.pageNumber;
  this.rowsPageCount = result.rowsPageCount;
  this.rowsPerPage = result.rowsPerPage;
  this.rows = result.rows;
  this.sortDataField = result.sortDataField;
  this.sortOrder = result.sortOrder;
  this.totalRowCount = result.totalRowCount;
  this.filters = result.filters;
  return super.load();
 }
}
